var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOriginMapDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 68,
    viewBox: "0 0 40 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    width: 2,
    height: 48,
    rx: 1,
    fill: "#009EFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#009EFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8518,
    y: 11.8516,
    width: 16.2963,
    height: 16.2963,
    rx: 8.14815,
    fill: "#14438E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginMapDarkMode);
export default __webpack_public_path__ + "static/media/origin-map-dark-mode.b3a723ff6ad7400d6fb63eee8c05c8dd.svg";
export { ForwardRef as ReactComponent };